module.exports = __webpack_public_path__ + "static/media/Elo Hand-01.a04e2465.svg";